import React, { useState, useEffect } from 'react'
import Header from '../../layouts/Header'
import {
    Button,
    Col,
    Row,
    Form,
    Table,
    Modal,
    Card,
    Pagination,
    Spinner,
    Alert,
    Dropdown
} from 'react-bootstrap'
import { Bell, Plus, Trash, Calendar, Clock, Image as ImageIcon, CheckCircle, XCircle } from 'react-bootstrap-icons'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import axiosInstance from '../../api/axios'
import { format } from 'date-fns'
import { toast } from 'react-toastify'

const BroadCast = () => {

    const [skin, setSkin] = useState('light')
    const accessToken = localStorage.getItem('authToken')
    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const [showAddModal, setShowAddModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [deletingId, setDeletingId] = useState(null)
    const [deletingTitle, setDeletingTitle] = useState('')

    // Toast state
    const [showToast, setShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [toastVariant, setToastVariant] = useState('success');

    //Loading States
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 25,
        total: 0,
        totalPages: 0
    })

    // Form state
    const [formData, setFormData] = useState({
        title: '',
        subTitle: '',
        startDate: null,
        endDate: null,
        time: '',
        type: 'PUSH',
        image: null
    })
    const [formErrors, setFormErrors] = useState({})
    const [uploading, setUploading] = useState(false)

    // Fetch notifications
    const fetchNotifications = async (page = 1, limit = pagination.limit) => {
        try {
            setLoading(true)
            const response = await axiosInstance.get(`alluser-notification-scheduler?limit=${limit}&page=${page}`)

            if (response.data.status) {
                setNotifications(response.data.data)
                setPagination({
                    ...response.data.pagination,
                    limit: limit
                })
                setError('')
            } else {
                setError(response.data.message || 'Failed to fetch notifications')
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error fetching notifications')
            console.error('Fetch error:', err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchNotifications()
    }, [])

    // Show toast notification
    const showToastMessage = (message, variant = 'success') => {
        setToastMessage(message)
        setToastVariant(variant)
        setShowToast(true)
    }

    // Handle add notification
    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsAddBtnLoading(true);
        // Validate form
        const errors = {}
        if (!formData.title.trim()) errors.title = 'Title is required'
        if (!formData.subTitle.trim()) errors.subTitle = 'Subtitle is required'
        if (!formData.startDate) errors.startDate = 'Start date is required'
        if (!formData.endDate) errors.endDate = 'End date is required'
        if (!formData.time) errors.time = 'Time is required'

        if (Object.keys(errors).length > 0) {
            setIsAddBtnLoading(false);
            setFormErrors(errors)
            return
        }

        // Format dates for API
        const formattedStartDate = format(formData.startDate, 'yyyy-MM-dd') + 'T00:00:00.000Z'
        const formattedEndDate = format(formData.endDate, 'yyyy-MM-dd') + 'T23:59:59.999Z'

        setFormErrors({})

        try {
            const data = new FormData()
            data.append('title', formData.title)
            data.append('subTitle', formData.subTitle)
            data.append('startDate', formattedStartDate)
            data.append('endDate', formattedEndDate)
            data.append('time', formData.time)
            data.append('type', formData.type)
            if (formData.image) {
                data.append('image', formData.image)
            }

            const response = await axiosInstance.post('alluser-notification-scheduler', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                console.log("Log in Outside Statement :", response);
            if (response.data.status) {
                fetchNotifications(pagination.page, pagination.limit)
                handleCloseAddModal();
                console.log("Log in If Statement :", response);

                toast.success(response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } catch (err) {
            handleApiError(err);
            console.error('Save error:', err)
        } finally {
            setIsAddBtnLoading(false);
        }
    }

    const handleApiError = (error) => {
        let errorMessage = 'An error occurred';
        if (error.response?.status === 406) {
            errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
        } else if (error.response?.status === 412) {
            errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
            errorMessage = error.response?.data?.error;
        }

        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
    };

    // Handle delete confirmation
    const handleDeleteClick = (id, title) => {
        setDeletingId(id)
        setDeletingTitle(title)
        setShowDeleteModal(true)
    }

    // Handle delete notification
    const handleDeleteConfirm = async () => {
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            }
            let reqbody = {
                id: deletingId
            }
            const response = await axiosInstance.delete(`alluser-notification-scheduler`, { headers, data: reqbody })
            console.log("Response of delete :", response);
            
            if (response.data.status === true) {
                fetchNotifications(pagination.page, pagination.limit)
                toast.success(response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } catch (err) {
            handleApiError(err);
        } finally {
            setIsDeleteBtnLoading(false);
            handleCloseDeleteModal();
        }
    }

    // Handle add new notification
    const handleAddNotification = () => {
        setFormData({
            title: '',
            subTitle: '',
            startDate: null,
            endDate: null,
            time: '',
            type: 'PUSH',
            image: null
        })
        setFormErrors({})
        setShowAddModal(true)
    }

    const handleCloseAddModal = () => {
        setShowAddModal(false)
        setFormErrors({})
    }

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false)
        setDeletingId(null)
        setDeletingTitle('')
    }

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value, files } = e.target
        if (name === 'image') {
            setFormData(prev => ({ ...prev, image: files[0] }))
        } else {
            setFormData(prev => ({ ...prev, [name]: value }))
        }
        // Clear error for this field
        if (formErrors[name]) {
            setFormErrors(prev => ({ ...prev, [name]: '' }))
        }
    }

    // Handle date changes
    const handleDateChange = (date, field) => {
        setFormData(prev => ({ ...prev, [field]: date }))
        if (formErrors[field]) {
            setFormErrors(prev => ({ ...prev, [field]: '' }))
        }
    }

    // Handle page change
    const handlePageChange = (pageNumber) => {
        fetchNotifications(pageNumber, pagination.limit)
    }

    // Handle records per page change
    const handleLimitChange = (limit) => {
        fetchNotifications(1, limit)
    }

    // Format date for display
    const formatDate = (dateString) => {
        return format(new Date(dateString), 'MMM dd, yyyy')
    }

    // Calculate serial number
    const getSerialNumber = (index) => {
        return (pagination.page - 1) * pagination.limit + index + 1
    }

    // Records per page options
    const limitOptions = [25, 50, 100, 200, 500]

    return (
        <>
            <Header onSkin={setSkin} />

            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    {/* Header */}
                    <Row className="pt-3">
                        <Col>
                            <div className="d-flex align-items-center justify-content-between mb-1">
                                <div className="d-flex align-items-center">
                                    <Bell className="me-3" size={26} color="#0d6efd" />
                                    <h4 className="fw-semibold mb-0">BROADCAST SCHEDULER</h4>
                                </div>
                                <Button
                                    variant="primary"
                                    onClick={handleAddNotification}
                                >
                                    <Plus size={16} className="me-2 fw-semibold" />
                                    Schedule Broadcast
                                </Button>
                            </div>
                        </Col>
                        <hr />

                    </Row>

                    {/* Error Alert */}
                    {error && (
                        <Row>
                            <Col>
                                <Alert variant="danger" onClose={() => setError('')} dismissible>
                                    {error}
                                </Alert>
                            </Col>
                        </Row>
                    )}

                    {/* Pagination Controls (ABOVE TABLE) */}
                    {!loading && notifications.length > 0 && (
                        <Row className="mb-3">
                            <Col>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <span className="me-2">Show</span>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-secondary" size="sm" id="dropdown-limit">
                                                {pagination.limit} records
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {limitOptions.map(option => (
                                                    <Dropdown.Item
                                                        key={option}
                                                        onClick={() => handleLimitChange(option)}
                                                        active={pagination.limit === option}
                                                    >
                                                        {option} records
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <span className="ms-2">of {pagination.total} total records</span>
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <Pagination className="mb-0">
                                            <Pagination.Prev
                                                onClick={() => pagination.page > 1 && handlePageChange(pagination.page - 1)}
                                                disabled={pagination.page === 1}
                                            />
                                            <Pagination.Item disabled>
                                                Page {pagination.page} of {pagination.totalPages}
                                            </Pagination.Item>
                                            <Pagination.Next
                                                onClick={() => pagination.page < pagination.totalPages && handlePageChange(pagination.page + 1)}
                                                disabled={pagination.page === pagination.totalPages}
                                            />
                                        </Pagination>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}

                    {/* Loading State */}
                    {loading ? (
                        <Row className="py-5">
                            <Col className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Loading broadcasts...</p>
                            </Col>
                        </Row>
                    ) : (
                        <>
                            {/* Notifications List */}
                            <Row>
                                <Col>
                                    {notifications.length === 0 ? (
                                        <Card className="text-center py-5">
                                            <Card.Body>
                                                <Bell size={48} className="text-muted mb-3" />
                                                <Card.Title>No Broadcasts</Card.Title>
                                                <Card.Text>
                                                    No scheduled broadcasts found. Click "Schedule Broadcast" to add one.
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    ) : (
                                        <div className="table-responsive">
                                            <Table hover>
                                                <thead>
                                                    <tr>
                                                        <th>Sr No.</th>
                                                        <th>Image</th>
                                                        <th>Title</th>
                                                        <th>Subtitle</th>
                                                        <th>Date Range</th>
                                                        <th>Time</th>
                                                        <th>Type</th>
                                                        <th>Created</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {notifications.map((notification, index) => (
                                                        <tr key={notification._id}>
                                                            <td>{getSerialNumber(index)}</td>
                                                            <td>
                                                                {notification.image && (
                                                                    <img
                                                                        src={notification.image}
                                                                        alt="Broadcast"
                                                                        style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
                                                                    />
                                                                )}
                                                            </td>
                                                            <td className="fw-semibold">{notification.title}</td>
                                                            <td>{notification.subTitle}</td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <Calendar size={14} className="me-1" />
                                                                    {formatDate(notification.startDate)} - {formatDate(notification.endDate)}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <Clock size={14} className="me-1" />
                                                                    {notification.time}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span className={`badge ${notification.type === 'PUSH' ? 'bg-primary' : 'bg-secondary'}`}>
                                                                    {notification.type}
                                                                </span>
                                                            </td>
                                                            <td>{formatDate(notification.createdAt)}</td>
                                                            <td>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => handleDeleteClick(notification._id, notification.title)}
                                                                    title="Delete"
                                                                >
                                                                    <Trash size={14} />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            {/* Pagination Footer */}
                            {notifications.length > 0 && (
                                <Row className="mt-3">
                                    <Col className="d-flex justify-content-center">
                                        <Pagination>
                                            <Pagination.Prev
                                                onClick={() => pagination.page > 1 && handlePageChange(pagination.page - 1)}
                                                disabled={pagination.page === 1}
                                            />
                                            {[...Array(pagination.totalPages)].map((_, i) => (
                                                <Pagination.Item
                                                    key={i + 1}
                                                    active={i + 1 === pagination.page}
                                                    onClick={() => handlePageChange(i + 1)}
                                                >
                                                    {i + 1}
                                                </Pagination.Item>
                                            ))}
                                            <Pagination.Next
                                                onClick={() => pagination.page < pagination.totalPages && handlePageChange(pagination.page + 1)}
                                                disabled={pagination.page === pagination.totalPages}
                                            />
                                        </Pagination>
                                    </Col>
                                </Row>
                            )}
                        </>
                    )}
                </div>
            </div>

            {/* Add Broadcast Modal */}
            <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Schedule New Broadcast</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.title}
                                        placeholder="Enter broadcast title"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.title}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Subtitle <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="subTitle"
                                        value={formData.subTitle}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.subTitle}
                                        placeholder="Enter broadcast subtitle"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.subTitle}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Start Date <span className="text-danger">*</span></Form.Label>
                                    <div>
                                        <DatePicker
                                            selected={formData.startDate}
                                            onChange={(date) => handleDateChange(date, 'startDate')}
                                            dateFormat="MMMM d, yyyy"
                                            className={`form-control ${formErrors.startDate ? 'is-invalid' : ''}`}
                                            placeholderText="Select start date"
                                            minDate={new Date()}
                                            isClearable
                                        />
                                    </div>
                                    {formErrors.startDate && (
                                        <div className="invalid-feedback d-block">
                                            {formErrors.startDate}
                                        </div>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>End Date <span className="text-danger">*</span></Form.Label>
                                    <div>
                                        <DatePicker
                                            selected={formData.endDate}
                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                            dateFormat="MMMM d, yyyy"
                                            className={`form-control ${formErrors.endDate ? 'is-invalid' : ''}`}
                                            placeholderText="Select end date"
                                            minDate={formData.startDate || new Date()}
                                            isClearable
                                        />
                                    </div>
                                    {formErrors.endDate && (
                                        <div className="invalid-feedback d-block">
                                            {formErrors.endDate}
                                        </div>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Time <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="time"
                                        name="time"
                                        value={formData.time}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.time}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.time}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Type</Form.Label>
                                    <Form.Select
                                        name="type"
                                        value={formData.type}
                                        onChange={handleInputChange}
                                    >
                                        <option value="PUSH">Push Notification</option>
                                        <option value="IN_APP">In-App Notification</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        <ImageIcon className="me-2" />
                                        Image
                                    </Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="image"
                                        onChange={handleInputChange}
                                        accept="image/*"
                                    />
                                    <Form.Text className="text-muted">
                                        Optional: Upload an image for the broadcast
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseAddModal}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={isAddBtnLoading}>
                            {isAddBtnLoading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Saving...
                                </>
                            ) : (
                                'Schedule Broadcast'
                            )}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-danger">
                        <Trash className="me-2" />
                        Confirm Delete
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        <XCircle size={48} className="text-danger mb-3" />
                        <h5>Are you sure you want to delete this broadcast?</h5>
                        <p className="text-muted">
                            <strong>"{deletingTitle}"</strong>
                        </p>
                        <p className="text-muted">
                            This action cannot be undone.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        <Trash size={16} className="me-2" />
                        { isDeleteBtnLoading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Deleting...
                            </>
                        ) : 'Delete'}
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default BroadCast